const React = require("react"),
    PropTypes = require('prop-types');
const {Table} = require("react-bootstrap");
const I18n = require("components/widgets/I18n"),
    FontAwesome = require("components/widgets/FontAwesome");

const TournamentResultEliminationTable = ({groupedTUserList, licColName, internalView}) => {
	return (
		<Table>
			<thead className="bowage-head">
			<tr>
				<th className="col-md-1"><I18n code="tournament.table.column.position"/></th>
				{
					licColName != null ? <React.Fragment>
							<th className="col-md-1 printCol-40">{licColName}</th>
							<th className="col-md-2 printCol-70"><I18n code="tournament.table.column.name"/></th>
						</React.Fragment>
						:
						<th className="col-md-3 printCol-110"><I18n code="tournament.table.column.name"/></th>
				}
				{
					internalView ? <th className="col-md-1"><I18n code="Qualifikation"/></th>
						: <th className="col-md-2 printCol-70"><I18n code="tournament.table.column.union"/></th>
				}
				<th className="col-md-2 printCol-100"><I18n code="tournament.round.type.FEG.defRoundName"/></th>
				<th className="col-md-2 printCol-70">Halbfinale</th>
				<th className="col-md-2 printCol-70">Finale</th>
			</tr>
			</thead>
			<tbody className="bowage-table">
			{
				groupedTUserList.map((tUser, index) => {
					return <TournamentUserRow key={"TUR_" + tUser.id} pos={index +1} tUser={tUser} licColName={licColName} internalView={internalView}/>
				})
			}
			</tbody>
		</Table>
	)
};
const TournamentUserRow = ({tUser, pos, licColName, internalView}) => {
	return <tr>
		<td>{pos}</td>
		{
			licColName ? <td>{tUser.getLicenseNumber()}</td> : null
		}
		<td>{tUser.getFullName()}</td>
		{
			internalView ? <td>{tUser.getSumPoints()}</td>
				: <td>{tUser.getUnion()}</td>
		}
		<TournamentMatchResultCell matchResult={tUser.getMatchResults()["group"]} showMatchScore={3} internalView={internalView}/>
		<TournamentMatchResultCell matchResult={tUser.getMatchResults()["half"]} showMatchScore={1}/>
		<TournamentMatchResultCell matchResult={tUser.getMatchResults()["final"]} showMatchScore={1}/>
	</tr>
};
const TournamentMatchResultCell = ({matchResult, showMatchScore, internalView}) => {
	if (matchResult != null) {
		let matchSumPoints = matchResult["sumPoints"]
		if (showMatchScore > 1 && !internalView) {
			matchSumPoints = <span>{matchResult["S1"]}&nbsp;&nbsp;{matchResult["S2"]}&nbsp;&nbsp;{matchResult["S3"]}</span>
		}
		return <td>
			<FontAwesome icon="star">{matchResult["matchPoints"]}</FontAwesome>&nbsp;&nbsp; <FontAwesome icon="edit">{matchSumPoints}</FontAwesome>
			<br/>{"\n"}
			<span><strong>#{matchResult["POS"]}</strong>&nbsp;{matchResult["name"]}</span>
		</td>

	}
	return <td></td>
}
TournamentResultEliminationTable.propTypes = {
	groupedTUserList:PropTypes.array.isRequired
};
module.exports = TournamentResultEliminationTable;